import { render, staticRenderFns } from "./MijnAccount.vue?vue&type=template&id=470902a9&"
import script from "./MijnAccount.vue?vue&type=script&lang=js&"
export * from "./MijnAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('470902a9')) {
      api.createRecord('470902a9', component.options)
    } else {
      api.reload('470902a9', component.options)
    }
    module.hot.accept("./MijnAccount.vue?vue&type=template&id=470902a9&", function () {
      api.rerender('470902a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/MijnAccount.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/MijnAccount.vue
// module id = 425
// module chunks = 0